var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeliu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4741"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 579",
    d: "M0.684692 4.68461L3.02526 2.84053C3.39495 2.54926 3.91772 2.5552 4.2807 2.8548L5.87088 4.16733C6.23601 4.46871 6.76244 4.47273 7.13214 4.17698L8.7869 2.85316C9.15891 2.55556 9.6892 2.5617 10.0542 2.86784L11.6096 4.17239C11.967 4.47209 12.484 4.48499 12.8559 4.20347L15.3153 2.34143",
    stroke: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 580",
    d: "M0.684692 9.17161L3.02526 7.32753C3.39495 7.03626 3.91772 7.0422 4.2807 7.3418L5.87088 8.65433C6.23601 8.95571 6.76244 8.95973 7.13214 8.66397L8.7869 7.34016C9.15891 7.04256 9.6892 7.0487 10.0542 7.35484L11.6096 8.65939C11.967 8.95909 12.484 8.97199 12.8559 8.69047L15.3153 6.82843",
    stroke: "#00C2FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 581",
    d: "M0.684692 13.6586L3.02526 11.8145C3.39495 11.5232 3.91772 11.5291 4.2807 11.8287L5.87088 13.1413C6.23601 13.4426 6.76244 13.4467 7.13214 13.1509L8.7869 11.8271C9.15891 11.5295 9.6892 11.5356 10.0542 11.8418L11.6096 13.1463C11.967 13.446 12.484 13.4589 12.8559 13.1774L15.3153 11.3154",
    stroke: "#00C2FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeliu);
export default __webpack_public_path__ + "static/media/heliu.05e19f9679c299a09ddb4a591b6f7f00.svg";
export { ForwardRef as ReactComponent };